import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router';
import { SYSTEM_ADMIN_PATH } from '../../../../constants';
import { fetchAdminTestDetailsRequest } from './Test/actions';
import UserTests from './UserTests';
import UserTestDetails from './UserTests/Details';

const Tests = React.lazy(() => import('.'));
const TestDetail = React.lazy(() => import('./Test/Details'));
const QuestionDetails = React.lazy(() => import('../Questions/Question/Details'));

const GetTestDetails = ({ match }) => {
     const dispatch = useDispatch();
     const test = useSelector((state) => state.admin.testDetails);
     const isLoading = useSelector((state) => state.general.isLoading);
     const testId = match.params.id;

     const fetchData = () => {
          if (test?.id !== testId) {
               dispatch(fetchAdminTestDetailsRequest(testId));
          }
     };
     useEffect(fetchData, []); // eslint-disable-line react-hooks/exhaustive-deps

     return <span>{isLoading ? '' : test?.name}</span>;
};

const GetQuestionDetails = ({ match }) => {
     const dispatch = useDispatch();
     const testId = match.params.id;
     const test = useSelector((state) => state.admin.testDetails);
     const listQuestion = test?.questions;

     const fetchData = () => {
          if (test?.id !== testId) {
               dispatch(fetchAdminTestDetailsRequest(testId));
          }
     };
     useEffect(fetchData, []); // eslint-disable-line react-hooks/exhaustive-deps

     let questionName = '';
     if (listQuestion) {
          questionName = 'Question: "' + listQuestion?.find((item) => item.id === match.params.questionId)?.question.replace(':', '') + '"';
     }

     return <span>{questionName}</span>;
};

const routes = {
     path: SYSTEM_ADMIN_PATH.TESTS,
     breadcrumb: 'Tests',
     element: <Outlet />,
     children: [
          { index: true, element: <Tests /> },
          {
               path: SYSTEM_ADMIN_PATH.TESTS_DETAIL,
               breadcrumb: GetTestDetails,
               element: <Outlet />,
               children: [
                    { index: true, element: <TestDetail /> },
                    {
                         path: SYSTEM_ADMIN_PATH.TEST_QUESTIONS_DETAIL,
                         breadcrumb: GetQuestionDetails,
                         element: <QuestionDetails />,
                    },
                    {
                         path: SYSTEM_ADMIN_PATH.TEST_USER_TESTS,
                         breadcrumb: 'User Tests',
                         element: <Outlet />,
                         children: [
                              { index: true, element: <UserTests /> },
                              {
                                   path: SYSTEM_ADMIN_PATH.TEST_USER_TEST_DETAILS,
                                   breadcrumb: 'Details',
                                   element: <UserTestDetails />,
                              },
                         ],
                    },
               ],
          },
     ],
};

export default routes;
